/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol extends models.ServiceAccountCredentialsBaseForKubernetesClusterAws {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol>): ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol(), model);
        ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol>): ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol.newInstance(<ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForKubernetesClusterAws.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForKubernetesClusterAwsAssumeRoleProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Role ARN. This is a required field.
     */
    assume_role_arn: string;

    /**
     * External ID configured in Assume Role. This is a required field.
     */
    assume_role_external_id: string;

    /**
     * Whether MFA enabled or not in Assume Role. This is a required field.
     */
    assume_role_mfa_enabled: boolean;

}
